import PageMetaInterface from "../../../interfaces/core/PageMetaInterface";

export default function Header({header, count}: {header: string, count: number})
{
    return (<div className="site-title__wrap">
        {header && <div className="site-title f-exp"><h1 className="site-title__h">{header}
        </h1><sup>{count}</sup></div>}
    </div>)
}